import * as _ from 'lodash';
import { Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IAppState, GpsActionCreators, IGpsDeviceListResponse, IAddGpsDeviceResponse, IVerifyGpsNumberResponse } from '@nkr/store/index';
import { IBaseResponse, IGpsDevice } from '@nkr/models/index';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import Grid from './grid';
import AddEdit from './add-edit';
import Delete from './delete';

interface IProps {
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getGpsDeviceList: () => Promise<IGpsDeviceListResponse>,
    updateGpsDevice: (deviceId: number, imei: string, gpsNumber: number, vendorId: number) => Promise<IBaseResponse>
    addGpsDevice: (imei: string, gpsNumber: number, vendorId: number) => Promise<IAddGpsDeviceResponse>,
    deleteGpsDevice: (deviceId: number) => Promise<IBaseResponse>,
    verifyGpsNumber: (deviceId: number, gpsNumber: number) => Promise<IVerifyGpsNumberResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    list: IGpsDevice[],
    currentDevice: {
        id: number,
        imei: string,
        gpsNumber: string,
        vendorId: number
    },
    delete: {
        show: boolean,
        id: number,
        imei: string,
        gpsNumber: number,
        vendor: string,
    }
}

class GpsList extends Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        currentDevice: {
            id: -1,
            imei: '',
            gpsNumber: '',
            vendorId: 0
        },
        delete: {
            show: false,
            id: 0,
            imei: '',
            gpsNumber: 0,
            vendor: '',
        }
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting list of gps, one moment please...').then(async () => {
            let response = await this.props.getGpsDeviceList();

            this.setState({
                list: response.data.results
            }, () => {
                this.props.hideLoading();
            });
        });
    }

    handleAddDevice = () => {
        this.setState({
            currentDevice: {
                id: 0,
                imei: '',
                gpsNumber: '',
                vendorId: 0
            },
            delete: {
                show: false,
                id: 0,
                imei: '',
                gpsNumber: 0,
                vendor: ''
            }
        });
    }

    handleEdit = (id: number) => {
        let data = this.state.list.find(x => x.id == id);
        let { imei, gpsNumber, vendorId } = data;

        this.setState({
            currentDevice: {
                id,
                imei,
                gpsNumber: gpsNumber.toString(),
                vendorId
            },
            delete: {
                show: false,
                id: 0,
                imei: '',
                gpsNumber: 0,
                vendor: ''
            }
        });
    }

    handleCancelAddEdit = () => {
        this.setState({
            currentDevice: {
                id: -1,
                imei: '',
                gpsNumber: '',
                vendorId: 0
            }
        });
    }

    handleAddEditFieldChange = (field: string, value: any) => {
        let currentDevice = _.cloneDeep(this.state.currentDevice);

        if (field == 'imei') {
            currentDevice.imei = value;
        }

        if (field == 'gpsNumber') {
            currentDevice.gpsNumber = value;
        }

        if (field == 'vendorId') {
            currentDevice.vendorId = parseInt(value);
        }

        this.setState({
            currentDevice
        });
    }

    handleSaveAddEdit = () => {
        let { id: deviceId, imei, gpsNumber, vendorId } = this.state.currentDevice;
        let vendor = vendorId == 0 ? 'Newgate' : 'Btracking'
        let list = _.cloneDeep(this.state.list);

        let success = false;

        this.props.showLoading('Saving GPS device, one moment please...').then(async () => {
            if (deviceId == 0) {
                let response = await this.props.addGpsDevice(imei, parseInt(gpsNumber), vendorId);

                if (response.data.success) {
                    list.push({
                        id: response.data.results,
                        imei,
                        gpsNumber: parseInt(gpsNumber),
                        vendorId,
                        vendor
                    });

                    success = true;
                }
            } else {
                let response = await this.props.updateGpsDevice(deviceId, imei, parseInt(gpsNumber), vendorId);

                if (response.data.success) {
                    list = list.map(item => {
                        if (item.id == deviceId) {
                            item.imei = imei;
                            item.gpsNumber = parseInt(gpsNumber);
                            item.vendorId = vendorId;
                            item.vendor = vendor;
                        }

                        return item;
                    });

                    success = true;
                }
            }

            this.setState({
                list,
                currentDevice: {
                    id: -1,
                    imei: '',
                    gpsNumber: '',
                    vendorId: -1
                }
            }, () => {
                this.props.hideLoading();

                if (success) {
                    toast.success('GPS device saved successfully');
                } else {
                    toast.error('Unable to save GPS device');
                }
            });
        });
    }

    handleConfirmDelete = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            currentDevice: {
                id: -1,
                imei: '',
                gpsNumber: '',
                vendorId: -1
            },
            delete: {
                show: true,
                id,
                imei: data.imei,
                gpsNumber: data.gpsNumber,
                vendor: data.vendor
            }
        });
    }

    handleDelete = () => {
        let list = _.cloneDeep(this.state.list);

        this.props.showLoading('Saving GPS device, one moment please...').then(async () => {
            let response = await this.props.deleteGpsDevice(this.state.delete.id);

            if (response.data.success) {
                list = list.filter(x => x.id != this.state.delete.id);

                this.setState({
                    list,
                    delete: {
                        show: false,
                        id: 0,
                        imei: '',
                        gpsNumber: 0,
                        vendor: ''
                    }
                }, () => {
                    toast.success('GPS device deleted successfully');
                });
            } else {
                toast.error('Unable to delete GPS device');
            }

            this.props.hideLoading();
        });
    }

    handleCancelDelete = () => {
        this.setState({
            delete: {
                show: false,
                id: 0,
                imei: '',
                gpsNumber: 0,
                vendor: ''
            }
        });
    }

    render = () => {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 30, marginBottom: 20, width: '40vw' }}>
                    <div>
                        <Button bsStyle='primary' bsSize='sm' onClick={this.handleAddDevice}>Add Device</Button>
                    </div>
                </div>

                <div style={{ display: 'flex' }}>
                    <div style={{ width: '40vw' }}>
                        <Grid
                            list={this.state.list}
                            onEdit={this.handleEdit}
                            onDelete={this.handleConfirmDelete}
                        />

                        <div>{this.state.list.length} devices...</div>
                    </div>
                    <div style={{ paddingLeft: 20, width: '35vw' }}>
                        {this.state.currentDevice.id >= 0 && (
                            <AddEdit
                                id={this.state.currentDevice.id}
                                imei={this.state.currentDevice.imei}
                                gpsNumber={this.state.currentDevice.gpsNumber}
                                vendorId={this.state.currentDevice.vendorId}
                                onChange={this.handleAddEditFieldChange}
                                onSave={this.handleSaveAddEdit}
                                onCancel={this.handleCancelAddEdit}
                                verifyGpsNumber={this.props.verifyGpsNumber} />
                        )}

                        {this.state.delete.show && (
                            <Delete
                                id={this.state.delete.id}
                                imei={this.state.delete.imei}
                                gpsNumber={this.state.delete.gpsNumber}
                                vendor={this.state.delete.vendor}
                                onConfirm={this.handleDelete}
                                onCancel={this.handleCancelDelete} />
                        )}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getGpsDeviceList: () => {
            return dispatch(GpsActionCreators.getGpsDeviceList());
        },
        updateGpsDevice: (deviceId, imei, gpsNumber, vendorId) => {
            return dispatch(GpsActionCreators.updateGpsDevice(deviceId, imei, gpsNumber, vendorId));
        },
        addGpsDevice: (imei, gpsNumber, vendorId) => {
            return dispatch(GpsActionCreators.addGpsDevice(imei, gpsNumber, vendorId));
        },
        deleteGpsDevice: (deviceId) => {
            return dispatch(GpsActionCreators.deleteGpsDevice(deviceId));
        },
        verifyGpsNumber: (deviceId, gpsNumber) => {
            return dispatch(GpsActionCreators.verifyGpsNumber(deviceId, gpsNumber));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(GpsList);